import { resolveScalarDisplay } from '../primitives/propertyBarDisplay';
import type { Database } from '../../types/database';

export type WorkItemPropertyDefRow =
  Database['public']['Tables']['work_item_property_defs']['Row'];
export type WorkItemPropertyValueRow =
  Database['public']['Tables']['work_item_property_values']['Row'];

export const TYPE_LABEL: Record<string, string> = {
  epic: 'Epic',
  story: 'Story',
  bug: 'Bug',
  task: 'Task',
  subtask: 'Subtask'
};

export const TYPE_LOCK_TOOLTIP =
  'Type is locked at creation. To change the type, archive this and create a new work item.';

export const NO_EPIC_VALUE = '__no_epic__';

export interface EpicOption {
  id: string;
  name: string;
}

export interface LoadedState {
  kind: 'ready';
  defs: WorkItemPropertyDefRow[];
  values: Map<string, WorkItemPropertyValueRow>;
}

export type LoadState =
  | { kind: 'loading' }
  | { kind: 'error'; message: string }
  | LoadedState;

export function formatDatePillValue(iso: string | null): string | null {
  if (!iso) return null;
  return resolveScalarDisplay({ kind: 'date', label: '' }, iso);
}
